import { Module } from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { State } from '@/main/store'
import { ProfileDataInitialState } from './types'

const profileStore: Module<ProfileDataInitialState, State> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default profileStore
